import { BandChartData } from "./types"

export const CHART_TOP_MARGIN = 80

export function findBestMultiplierForTicks(bands: BandChartData, desiredTickCount: number) {
  const multipliers = [1, 10, 100, 1000, 10000, 100000, 1000000]
  const overallMin = Math.min(...bands.map(band => band?.min ?? -1).filter(b => b !== -1))
  const overallMax = Math.max(...bands.map(band => band?.max ?? -1).filter(b => b !== -1))

  let bestMultiplier = multipliers[0]
  let bestScore = Infinity // Lower score is better.

  multipliers.forEach(multiplier => {
    const scaledMin = Math.floor(overallMin / multiplier)
    const scaledMax = Math.ceil(overallMax / multiplier)
    const range = scaledMax - scaledMin
    const idealInterval = range / (desiredTickCount - 1)

    // Calculate how "round" the interval is. Closer to a round number is better.
    const roundnessScore = Math.abs(idealInterval - Math.round(idealInterval))

    // Calculate the deviation from the ideal number of ticks.
    const actualTicks = Math.round(range / Math.round(idealInterval))
    const tickDeviationScore = Math.abs(desiredTickCount - 1 - actualTicks)

    // A combined score that prioritizes round intervals and correct number of ticks.
    const score = roundnessScore + tickDeviationScore

    if (score < bestScore) {
      bestScore = score
      bestMultiplier = multiplier
    }
  })

  return bestMultiplier
}

export function roundNumber(number: number | string) {
  const num = typeof number === "string" ? parseFloat(number) : number
  if (num >= 1_000_000) {
    return `${(num / 1000000).toFixed(1)}M`
  }
  if (num >= 10_000) {
    return `${(num / 1000).toFixed(0)}k`
  }

  return num.toFixed(0)
}

/**
 * Rounds the number from the `USD 120,000` format.
 * @param money string
 */
export function roundNumberFromMoney(money: string) {
  const num = Number(money.replace(/[^0-9.]/g, ""))
  return roundNumber(num)
}
